export const hca = ((chart) => {
    const placeHolderText = `${chart.HEALTHCARE_AGENT_INFO.agent}`

    return placeHolderText
})